import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { useEffect, useRef } from "react";

const MyOpenLayersMap = () => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null); // Prevent multiple instances

  useEffect(() => {
    if (!mapInstance.current) { // Check if map already exists
      mapInstance.current = new Map({
        target: mapRef.current,
        layers: [new TileLayer({ source: new OSM() })],
        view: new View({
          center: [-9371492, 4048661], // Convert to OpenLayers projection
          zoom: 4,
          projection: "EPSG:3857", // Ensure correct projection
        }),
      });
    }
  }, []);

  return <div ref={mapRef} style={{ width: "100%", height: "500px" }} />;
};

export default MyOpenLayersMap;
